import React, {useEffect, useState} from 'react'
import {Helmet} from 'react-helmet'
import { getPerformanceCookie } from '../../../../../../utils/general'

const WistiaVideoEmbed = ({ id, play = true, style, options, mobile }) => {
    let performanceCookieOn = false;
    if (typeof window !== 'undefined') {
      performanceCookieOn = getPerformanceCookie(window);
    }
    const [video, setVideo] = useState()
  
    useEffect(() => {
      if (!video) return
      if (play) {
        video.play()
      } else {
        video.pause()
      }
    }, [play, video])
  
    useEffect(() => {
      window._wq = window._wq || []
  
      // RUN WEBSITE IN PRICAVY MODE
      window._wq.push(function (W) {
        W.consent(false)
      })
  
      window._wq.push({
        id,
        options: {
          // PLAYBACK
          preload: true,
          muted: false,
          playsinline: true,
          autoPlay: play,
          silentAutoPlay: false,
          endVideoBehavior: 'loop',
  
          // LAYOUT
          fitStrategy: 'cover',
          videoFoam: false,
  
          // TRACKING
          copyLinkAndThumbnailEnabled: false,
          doNotTrack: true,
          googleAnalytics: false,
          seo: false,
  
          // DEFAULT QUALITY
          // qualityMax,
          // qualityMin,
  
          // UI CONTROLS
          controlsVisibleOnLoad: true,
          fullscreenOnRotateToLandscape: false,
          fullscreenButton: true,
          settingsControl: false,
          qualityControl: false,
          playButton: true,
          playbar: false,
          playbackRateControl: false,
          smallPlayButton: false,
  
          ...options,
        },
        onReady: myOnReady,
        onHasData: () => {
        },
      })
    }, [])
  
    const onPlayEvent = () => {
    }
  
    useEffect(() => {
      if (!video) return
  
      video.bind('play', onPlayEvent)
      video.bind('beforeremove', function () {
        return video.unbind
      })
      return () => {
        video.unbind('play', onPlayEvent)
        video.remove() // clean up
      }
    }, [video])
  
    const myOnReady = (video) => {
      setVideo(video)
    }
  
    return performanceCookieOn ? (
      <div className={mobile ? 'mobile wistia-video' : 'wistia-video'}>
        <Helmet>
          <script src={`https://fast.wistia.com/embed/medias/${id}.jsonp`} async></script>
          <script src="https://fast.wistia.com/assets/external/E-v1.js" async></script>
        </Helmet>
        <div className={`wistia_embed wistia_async_${id} wistia-embed`} style={{ height: '100%', ...style }}></div>

        <style jsx>{`
            .wistia-video {
                position: absolute;
                z-index: 2;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                height: 36.6vw;
                width: 65%;
            }
            .wistia-embed {
                height: 100%;
                // position: absolute;
                // z-index: 2;
                // top: 50%;
                // left: 50%;
                // transform: translate(-50%, -50%);
                // height: auto;
                // height: 50%;
                // width: 50%;
            }

            @media (max-width: 769px), (pointer: coarse){
                .wistia-video {
                    display: block;
                    position: static; 
                    transform: none;
                    width: 100%;
                    // height: 300px;
                    // height: auto;
                    height: 56.25vw;
                }

                .wistia-embed {
                    // width: 100%;
                    // height: 100%;
                    // height: 0 !important;
                    // padding-bottom: 56.25%;

                }
            }
        `}</style>
      </div>
    ) : null
  }

  export default WistiaVideoEmbed